import $ from 'jquery';

const mainHeaderSliderLoaded = () => {
	let gtmSendGoals = null;
	const animateDuration = 500;
	const animateClass = 'animate';
	const slickContainer = $('.js--md-header-slider');
	const slides = $('.js--md-header-slider_item');
	const navButtonNextSelector = '.md-header-slider_nav-button-next';
	const navButtonPrevSelector = '.md-header-slider_nav-button-prev';
	const animateItemsSelectors = [
		'.md-header-slider_item-info-title',
		'.md-header-slider_item-info-description',
		'.md-header-slider_item-info-button',
		'.md-header-slider_item-phone',
		'.md-header-slider_item-demo'
	];

	window.addEventListener('load', function () {
		let counter = 0;
		gtmSendGoals = (currentSlide, slidesLength) => {
			const goal = currentSlide.getAttribute('data-gtm-goal');
			if (goal) {
				/* eslint-disable */
				gtag('event', goal, {
					'event_category': 'slider',
					'event_label' : `slide${counter + 1}`
				});
				/* eslint-enable */
				counter++;
				currentSlide.removeAttribute('data-gtm-goal');
			}
			if (slidesLength === counter) {
				gtmSendGoals = null;
			}
		};

		gtmSendGoals(slides[0], slides.length);
	});

	slickContainer.slick({
		autoplay: true,
		autoplaySpeed: 9000,
		pauseOnFocus: false,
		fade: true,
		dots: true,
		draggable: false,
		speed: animateDuration,
		prevArrow: navButtonPrevSelector,
		nextArrow: navButtonNextSelector
	});

	slickContainer.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
		for (let i = 0; i < animateItemsSelectors.length; i++) {
			const el = slick.$slides[nextSlide].querySelector(animateItemsSelectors[i]);
			if (el) {
				el.classList.add(animateClass);
			}
		}

		setTimeout(() => {
			for (let i = 0; i < animateItemsSelectors.length; i++) {
				const el = slick.$slides[currentSlide].querySelector(animateItemsSelectors[i]);
				if (el) {
					el.classList.remove(animateClass);
				}
			}
		}, [animateDuration]);
	});

	slickContainer.on('afterChange', (event, slick, currentSlide) => {
		if (gtmSendGoals) {
			gtmSendGoals(slick.$slides[currentSlide], slick.$slides.length);
		}
	});
};

const render = () => {
	mainHeaderSliderLoaded();
};

export default render;
